/* Product page review */
$(document).ready(function () {
  setTimeout(function () {
    if ($("div").hasClass("jdgm-rev-carousel")) {
      $(".jdgm-row-readmore").prepend(
        '<button class="review-btn">Write a review</button>'
      );
      $(".review-btn").on("click", function () {
        $(".jdgm-row-stars").toggleClass("star-row-flex");
      });
    } else {
      $(".jdgm-rev-widg__title").append(
        '<br><h3>There are not any reviews for this product yet!</h3><br><button class="review-btn">Write a review</button>'
      );
      $(".review-btn").on("click", function () {
        $(".jdgm-row-stars").toggleClass("star-row-flex");
      });
    }
  }, 3000);

  $(".bg-dark").slick({
    arrow: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: 1,
    slidesToScroll: 1,
  });

  /* Slick on home banner */
  $(".banner-slider").slick({
    vertical: true,
    verticalSwiping: true,
    slidesToShow: 1,
    slidesToScroll: 1,
  });

  /* Slick on review */
  $("#reviewCarousel").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    loop: false,
  });

  /* Slick for video */
  $(".video-slider").slick({
    slidesToShow: 1,
    dots: true,
  });

  // video slider number controls
  var $slickElement = $(".video-slider");
  $slickElement.on(
    "init reInit afterChange",
    function (event, slick, currentSlide, nextSlide) {
      var i = (currentSlide ? currentSlide : 0) + 1;
    }
  );
});

/* Menu toggle bar */
$("#navbarCollapse").click(function () {
  $(".navigation-main").toggleClass("nav-show");
  $("#navbarCollapse").toggleClass("nav-open");
});

/* Slick slider */
// Initialize slick slider
document.addEventListener("DOMContentLoaded", function () {
  $(".myslider").slick({
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    adaptiveHeight: true,
    autoplay: false,
    autoplaySpeed: 3000,
    vertical: true,
    verticalSwiping: true,
    swipe: false,
  });

  // Custom next button click event
  document
    .getElementById("custom-next-btn")
    .addEventListener("click", function () {
      $(".myslider").slick("slickNext");
    });
});

/* Video slider */
$(".video_slider").slick({
  slidesToScroll: 1,
  arrows: false,
  dots: true,
  vertical: true,
  verticalSwiping: true,
  arrows: true,
});

/* Accordion */

let question = document.querySelectorAll(".question");

question.forEach((question) => {
  question.addEventListener("click", (event) => {
    const active = document.querySelector(".question.active");
    if (active && active !== question) {
      active.classList.toggle("active");
      active.nextElementSibling.style.maxHeight = 0;
    }
    question.classList.toggle("active");
    const answer = question.nextElementSibling;
    if (question.classList.contains("active")) {
      answer.style.maxHeight = answer.scrollHeight + "px";
    } else {
      answer.style.maxHeight = 0;
    }
  });
});

function addAnchorToIcons() {
  var $icons = document.querySelectorAll(`.list-social__item a`);
  if (!$icons) {
    return;
  }

  for (var each of $icons) {
    each.setAttribute("target", "_blank");
  }
}
addAnchorToIcons();

/* Video popup */
$(document).ready(function () {
  $(".popup-btn").on("click", function () {
    $(".video-popup").css({ height: "100%", width: "100%", opacity: "1" });
    return false;
  });

  $(".popup-bg").on("click", function () {
    $(".video-popup").slideUp("slow");
    return false;
  });

  $(".close-btn").on("click", function () {
    $(".video-popup").fadeOut("slow");
    return false;
  });
});

var $links = $("div.veryHigh");
$links.click(function () {
  $links.removeClass("selected");
  $(this).addClass("selected");
});

$(window).on("load", function () {
  $(".index-app-review-section .jdgm-carousel__item-container").addClass(
    "judge-bg"
  );
});

/* Product varinat on change */
jQuery(function () {
  $(".select__select").on("change", function () {
    var varlabel = $(this).val().toLowerCase();
    $(".cs-swatch-feature").attr("data-swatch", varlabel);
    $(".cs-swatch-feature").css("background-color", varlabel);
  });
});

/********* collection-filter-menu *******/

$(".parent_wrap li .icon_wrap_arrow").click(function () {
  var test_var = $(this).closest(".parent_wrap li").hasClass("current");
  if (test_var == true) {
    $(".parent_wrap li").removeClass("current");
  } else {
    $(".parent_wrap li").removeClass("current");
    $(this).closest(".parent_wrap li").addClass("current");
  }
});

$(function () {
  var header = $(".cs-promotion-bar");
  $(window).scroll(function () {
    var scroll = $(window).scrollTop();

    if (scroll >= 100) {
      header
        .removeClass("cs-promotion-bar")
        .addClass(
          "cs-promotion-bar shopify-section-header-hidden shopify-section-header-sticky"
        );
    } else {
      header
        .removeClass(
          "cs-promotion-bar shopify-section-header-hidden shopify-section-header-sticky"
        )
        .addClass("cs-promotion-bar");
    }
  });
});

$(function () {
  var header = $(".section-header");
  $(window).scroll(function () {
    var scroll = $(window).scrollTop();

    if (scroll >= 100) {
      header
        .removeClass("section-header")
        .addClass(
          "section-header shopify-section-header-hidden shopify-section-header-sticky"
        );
    } else {
      header
        .removeClass(
          "section-header shopify-section-header-hidden shopify-section-header-sticky"
        )
        .addClass("section-header");
    }
  });
});

$(function () {
  $("ul.list_fonts li:first").clone().appendTo("#display_fonts");

  $("ul.list_fonts li").on("click", function () {
    $("#display_fonts").html("");
    $(this).clone().appendTo("#display_fonts");
    $("ul.list_fonts").slideUp();
  });
  $("#display_fonts").click(function () {
    $("ul.list_fonts").slideToggle();
  });

  $(".list_fonts")
    .find("li")
    .click(function () {
      var li_val = $(this).attr("value");
      $("#display_fonts_hidden").val(li_val);
    });
});

$(".faq-wrapper .faq-slides").slice(10).hide();

var mincount = 10;
var maxcount = 30;
if ($(".faq-wrapper").length > 0) {
  $(window).scroll(function () {
    if (
      $(window).scrollTop() + $(window).height() >=
      $("#faq-end").offset().top
    ) {
      $(".faq-wrapper .faq-slides").slice(mincount, maxcount).slideDown(1400);

      mincount = mincount + 10;
      maxcount = maxcount + 30;
    }
  });
}

// Quick & dirty toggle to demonstrate modal toggle behavior
$(".gallery-modal-toggle").on("click", function (e) {
  e.preventDefault();
  $(".gallery-modal").toggleClass("is-visible");
});

$(function () {
  // This is for the auto sliding
  /*
    setInterval(function () {
        moveRight();
    }, 3000);
  */
  var slideCount = $(".gallery-slider ul li").length;
  var slideWidth = $(".gallery-slider ul li").width();
  var slideHeight = $(".gallery-slider ul li").height();
  var slideUlWidth = slideCount * slideWidth;

  $(".gallery-slider").css({ "max-width": slideWidth, height: slideHeight });
  $(".gallery-slider ul").css({
    width: slideUlWidth,
    "margin-left": -slideWidth,
  });
  $(".gallery-slider ul li:last-child").prependTo($(".gallery-slider ul"));

  function moveLeft() {
    $(".gallery-slider ul")
      .stop()
      .animate(
        {
          left: +slideWidth,
        },
        700,
        function () {
          $(".gallery-slider ul li:last-child").prependTo(
            $(".gallery-slider ul")
          );
          $(".gallery-slider ul").css("left", "");
        }
      );
  }

  function moveRight() {
    $(".gallery-slider ul")
      .stop()
      .animate(
        {
          left: -slideWidth,
        },
        700,
        function () {
          $(".gallery-slider ul li:first-child").appendTo(
            $(".gallery-slider ul")
          );
          $(".gallery-slider ul").css("left", "");
        }
      );
  }

  $(".gallery-next").on("click", function () {
    moveRight();
  });

  $(".gallery-prev").on("click", function () {
    moveLeft();
  });
});

jQuery(function () {
  jQuery(".swatch-element :radio").change(function () {
    if ($(this).is(":checked")) {
      $(this).parent("label").addClass("selected");
    }
    $(this)
      .closest(".product_color_warpper")
      .find("li input:not(:checked)")
      .parent("label")
      .removeClass("selected");
    var optionValue = jQuery(this).attr("data-image");
    var optionID = jQuery(this).attr("data-id");
    var optionaAvail = jQuery(this).attr("data-available");
    console.log(optionaAvail);
    if (optionaAvail == "false") {
      jQuery(this)
        .closest("li")
        .closest(".card--media")
        .find(".card-grid-sold")
        .html("SOLD OUT");
    } else {
      jQuery(this)
        .closest("li")
        .closest(".card--media")
        .find(".card-grid-sold")
        .html("");
    }
    jQuery(this)
      .closest("li")
      .closest(".card--media")
      .find(".product-img img")
      .attr("src", optionValue);
    jQuery(this)
      .closest("li")
      .closest(".card--media")
      .find(".product-img a")
      .attr("href", optionID);
    jQuery(this)
      .closest("li")
      .closest(".card--media")
      .find(".card__heading a")
      .attr("href", optionID);
    jQuery(this)
      .closest("li")
      .closest(".card--media")
      .find(".last a")
      .attr("href", optionID);
  });

  /* jQuery('.product-form__submit').click(function(){
          //jQuery(".bold_option_element select").val(select_first).attr('aria-selected', 'false');
          setTimeout(function () {
            var select_first = jQuery(".bold_option_element select option:eq(1)").val();
            jQuery(".bold_option_element select").val(select_first).trigger('change');
            jQuery(".bold_option_element select").val(select_first).attr('aria-selected', 'true');
          }, 1000);
        });  
  */
});
